// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderMini_container__T_IT2","menuVersionV3":"HeaderMini_menuVersionV3__MWWWx","hasSubMenuV2":"HeaderMini_hasSubMenuV2__bVKVD"};